export default "__VITE_ASSET__LzMXb$MZ__"